import { BackendResponse } from "../BackendResponse";
import { NextApiParams, withNextApi } from "../nextApiHelpers";

export interface GetSettingsResponse extends BackendResponse {
  item: CvpSettingsFromServer;
}

export interface GetSettingsParameters extends NextApiParams {
  idEmbed: string | null;
  type: "merged" | "general" | "embed";
}

// only use on the admin page
export const getSettings = withNextApi<
  GetSettingsResponse,
  GetSettingsParameters
>("/CvpSettings/CvpGetSettings", { method: "GET" });

export interface CvpSettingsFromServer {
  idConcern: string;
  idEmbed: string;
  settings: { [key: string]: string };
}
